"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.clientConfig = void 0;
function clientConfig(configProvider) {
    const config = typeof configProvider === 'function' ? configProvider : () => configProvider;
    return {
        get redisConfigurationEndpoint() {
            return config().getRequired('REDIS_CONFIGURATION_ENDPOINT');
        },
        get redisPort() {
            const port = config().get('REDIS_PORT');
            return port ? parseInt(port, 10) : 6379;
        },
        get envName() {
            return config().getRequired('REDIS_ENV_NAME');
        },
        get cacheEnabled() {
            return config().get('REDIS_CACHE_ENABLED') !== 'false';
        },
        get cacheType() {
            return config().get('REDIS_CACHE_TYPE') || 'redis';
        },
    };
}
exports.clientConfig = clientConfig;
//# sourceMappingURL=clientConfig.js.map